import { reducerRegistry } from '../../../../reducerRegistry';

import listsReducersMap from './lists/reducersMap';
import collectionsReducersMap from './collections/reducersMap';
import formsReducersMap from './forms/reducersMap';

const combineMap = {
  lists: listsReducersMap,
  collections: collectionsReducersMap,
  forms: formsReducersMap
};

export default function combineRegistry() {
  reducerRegistry.registerByCombineMap('contests', combineMap);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/contests/reducers/static/combineRegistry.js